import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export interface AutoSelectRule {
    TargetCategoryId: string;
    TargetProductId: string;
}

export interface MaterialCategory {
    Id: string;
    Name: string;
    DefaultFormula?: string;
}

export interface MaterialProduct {
    Id: string;
    CategoryId: string;
    ManufacturerId: string;
    Name: string;
    CustomFormula?: string | null;
    AutoSelectRules?: AutoSelectRule[];
}

export interface MaterialFormulasData {
    Categories: MaterialCategory[];
    Products: MaterialProduct[];
}

export default function useMaterialFormulas() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useList() {
        return useQuery<MaterialFormulasData>({
            queryKey: ["material-formulas"],
            queryFn: async () => {
                const response = await axiosPrivate.get(
                    "/v1/formulas/materials",
                );
                return parseSuccessResponseData(
                    response,
                ) as MaterialFormulasData;
            },
        });
    }

    function useSave() {
        return useMutation({
            mutationFn: async (data: MaterialFormulasData) => {
                const response = await axiosPrivate.put(
                    "/v1/formulas/materials",
                    data,
                );
                return parseSuccessResponseData(response);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["material-formulas"],
                });
            },
        });
    }

    return { useList, useSave };
}
